import { jwtDecode } from 'jwt-decode';
import { User, UserRole } from '../types';

const ROLE_HIERARCHY: Record<UserRole, number> = {
  [UserRole.SUPER_ADMIN]: 4,
  [UserRole.ENTERPRISE_ADMIN]: 3,
  [UserRole.EMPLOYEE]: 2,
  [UserRole.USER]: 1,
};

export const authService = {
  getUserFromToken: (token: string): User | null => {
    if (!token) return null;
    try {
      const decoded: any = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) return null;
      return {
        userId: decoded.user_id,
        email: decoded.email,
        name: decoded.name,
        role: decoded.role as UserRole,
        companyId: decoded.company_id,
        isActive: decoded.is_active,
        governanceMode: decoded.governance_mode,
        visibility: decoded.token_visibility,
      };
    } catch (err) {
      return null;
    }
  },

  hasRequiredRole: (user: User | null, allowedRoles: UserRole[]): boolean => {
    if (!user) return false;
    const userLevel = ROLE_HIERARCHY[user.role] || 0;
    return allowedRoles.some(role => userLevel >= (ROLE_HIERARCHY[role] || 0));
  }
};
